import './Grid.css';
import React from 'react';
import classnames from 'classnames';
import { SpacingSizes } from '../Stack/Stack';
import GlobalProps from '../globalProps';
interface Props extends GlobalProps {
  columns?: number;
  flex?: boolean;
  gap?: SpacingSizes;
  noWrap?: boolean;
  noStretch?: boolean;
}

export function Grid({
  columns = 2,
  children,
  flex,
  gap = 'lg',
  noWrap,
  className,
  style,
  noStretch,
}: Props): JSX.Element {
  return (
    <div
      style={style}
      className={classnames(
        'grid',
        `grid--columns-${columns}`,
        `grid--gap-${gap}`,
        {
          'grid--flex': flex,
          'grid--no-wrap': noWrap,
          'grid--no-stretch': noStretch,
        },
        className
      )}
    >
      {children}
    </div>
  );
}
